class SubcategoriaProductoTraduccion
{
  idSubcategoriaProductoTraduccion = 0;
  nombreSubcategoria = null;
  subcategoriaProducto_idSubcategoriaProducto = 0;
  idiomas_idIdioma = 0;
  idioma = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = SubcategoriaProductoTraduccion;
